import { Component } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { companyItem } from '../company/company.interface';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { KeycloakService } from 'keycloak-angular';
import { AppURL } from 'src/app/app.url';
import { DataService } from 'src/app/services/data.service';
import { Title } from '@angular/platform-browser';
import { FaviconServiceService } from 'src/app/services/favicon-service.service';

@Component({
  selector: 'app-to-system',
  templateUrl: './to-system.component.html',
  styleUrls: ['./to-system.component.scss']
})
export class ToSystemComponent {
  system: string = ""
  systemid: string = ""
  constructor(private app: AppService,
    private http: HttpClient,
    private ac: ActivatedRoute,
    private kc: KeycloakService,
    private router: Router,
    public ds: DataService,
    private titleService: Title,
    private setFavicon: FaviconServiceService) {
    this.system = this.ac.snapshot.queryParams['system']
    this.systemid = this.ac.snapshot.params['systemid']
    if (this.systemid) this.getStyleList()

    this.app.viewPage = false;
    this.getCompany();
  }

  styleItems: any;
  getStyleList() {
    this.http.get(`style/${this.systemid}`).subscribe({
      next: (res: any) => {
        this.styleItems = res.data
        this.ds.styleItems = this.styleItems
        this.titleService.setTitle(this.ds.styleItems.System);
        this.setFavicon.setFavicon(`${environment.contentPackage}/${this.ds.styleItems.Logo}`)
      }
    })
  }

  companyItem!: companyItem[];
  getCompany() {
    this.http.get(`organizations`).subscribe({
      next: (res: any) => {
        this.companyItem = res.data;
        this.companyItem.forEach((f: companyItem) => {
          if (f.Organization_logo) f.Organization_logo = environment.contentOG + '/' + f.Organization_logo
        })

      }
    })
  }

  toSystem(cm: companyItem) {
    let URL: string = this.system + '/check?og=' + cm.Organization_id + '&realmid=' + cm.RealmId
    window.location.replace(URL)

  }

  actionView: boolean = false
  addOrganization() {
    this.actionView = true
  }

  updateItem(e: any) {
    this.getCompany();
    this.actionView = false
  }

  close() {
    this.actionView = false
  }

  ToDashbaord() {
    this.app.viewPage = true;
    this.router.navigate(['/', AppURL.organization])
  }


  logout() {
    this.kc.logout()
    window.location.replace(this.system)
  }
}


